import React, { Component } from 'react';
import YouTube from 'react-youtube';
import { Grid, Row, Col, Thumbnail, Button, Panel, PanelGroup, Image, Collapse, Fade } from 'react-bootstrap';
import { AwesomeButton, AwesomeButtonSocial } from 'react-awesome-button';
import { AutoAffix } from 'react-overlays';

import 'react-awesome-button/dist/styles.css';
import 'react-awesome-button/dist/themes/theme-blue.css';
import './Blurb.css'


export default class TinyEngineBlurb extends React.Component {
    constructor(props, context) {
        super(props, context);
    }

    render() {
        return (
            <div>
                <h3>TinyEngine</h3>
                <p className='blurb-text'>TinyEngine is a small game engine  which allows users to write games in python, using TinyEngine’s API (written in C++) to handle more complex game systems.
</p>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/TinyEngineBlurb.jsx